import { __rest } from "tslib";
import React, { forwardRef, useEffect, useRef } from 'react';
import { createReactWrapper } from '../common/PrefixUtils';
import { addExtraProps } from '../common/utils/AddExtraProps';
import { handleForwardRef } from '../common/RefUtils';
export const Popover = forwardRef((_a, ref) => {
    var { children, trigger, triggerOn, zIndex, isOpen, onChange } = _a, props = __rest(_a, ["children", "trigger", "triggerOn", "zIndex", "isOpen", "onChange"]);
    const popoverRef = useRef();
    const handledRef = handleForwardRef(popoverRef, ref);
    const handleChange = (event) => {
        onChange === null || onChange === void 0 ? void 0 : onChange(event.detail.isOpen);
    };
    useEffect(() => {
        var _a;
        (_a = popoverRef.current) === null || _a === void 0 ? void 0 : _a.addEventListener('popoverchange', handleChange);
        return () => {
            var _a;
            (_a = popoverRef.current) === null || _a === void 0 ? void 0 : _a.removeEventListener('popoverchange', handleChange);
        };
    }, [ref, onChange]);
    return createReactWrapper({
        tagName: 'chameleon-popover',
        props: Object.assign(Object.assign({}, props), { ref: handledRef, 'z-index': zIndex, 'is-open': isOpen, 'trigger-on': triggerOn }),
        children: (React.createElement(React.Fragment, null,
            addExtraProps(trigger, { slot: 'trigger' }),
            React.createElement("div", { slot: "content" }, children))),
    });
});
